// the reason why this file exists is to help us determine if we should treat a path in a url as a *
// for example, if twitter were using Jam we'd want the comments to appear on any url that's like
// twitter.com/*/tweet/* rather than on a specific user/tweet
// so this function makes an educated guess about whether a path in a url is an id and needs to be a wildcard or a section

interface PathPartId {
	type: "id"
}

interface SectionPathPart {
	type: "section"
}

export default function idOrSection(str: string): PathPartId | SectionPathPart {
	// if both dashes and underscores probably an id
	if (str.includes("-") && str.includes("_")) {
		return { type: "id" }
	}

	// any @ is a clue it's an id
	if (str.includes("@")) {
		return { type: "id" }
	}

	// if one letter section, then it's a section
	// but if a one number section then it's an id
	if (str.length === 1) {
		if (str.match(/[a-z]/i)) {
			return { type: "section" }
		} else {
			return { type: "id" }
		}
	}

	// if it's all numbers, it's an id
	if (!isNaN(Number(str))) {
		return { type: "id" }
	}

	// if there is more than two uppercase and two lowercase it's an id
	if (
		(str.match(/[A-Z]/g) || []).length > 2 &&
		(str.match(/[a-z]/g) || []).length > 2
	) {
		return { type: "id" }
	}

	// if more than 3 underscores or more than 3 dashes, it's an id
	if (
		(str.match(/-/g) || []).length > 3 ||
		(str.match(/_/g) || []).length > 3
	) {
		return { type: "id" }
	}

	// now split by underscore or dashes to look at the pieces
	let arr = str.includes("-") ? str.split("-") : str.split("_")

	// for each in arr, check mix of numbers and letters
	const isIdArray = arr.map((substring) => {
		// if it is a combo of # and letters, probably an id
		if (
			(substring.match(/[0-9]/g) || []).length > 0 &&
			(substring.match(/[A-Za-z]/g) || []).length > 0
		) {
			return true
		}

		// if there is more than two uppercase and two lowercase it's an id
		if (
			(substring.match(/[A-Z]/g) || []).length > 2 &&
			(substring.match(/[a-z]/g) || []).length > 2
		) {
			return true
		}

		// if it is only numbers, then it is an id
		if (!isNaN(Number(substring))) {
			return true
		}

		// if all caps, probably id
		if (substring === substring.toUpperCase()) {
			return true
		}

		return false
	})

	if (isIdArray.indexOf(true) > -1) return { type: "id" }

	return { type: "section" }
}
